import React from 'react';
import Slider from "react-slick";
import Link from '../../Link';
import Button from '../../Button';

import ArrowLeftWhite from '../../animateArrow/ArrowLeftWhite';
import ArrowRightWhite from '../../animateArrow/ArrowRightWhite';
import ProductBgArrow from '../../animateArrow/ProductBgArrow';
import Card from '../../card/SongsCard';

import PropTypes from 'prop-types';

const LifeCircleSongsCarousel = (props) => {
  const settings = {
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    rows: 2,
    slidesPerRow: 3,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          arrows: true,
          rows: 2,
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesPerRow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          rows: 2,
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesPerRow: 1,
          variableWidth: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          rows: 2,
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesPerRow: 1,
          variableWidth: true
        }
      }
    ]
  }

  const renderBg = () => {
    switch (props.bgStyle) {
      case 'arrow':
        return <div className="section-bg"><ProductBgArrow /></div>
      default:
        return (
          <div className="section-bg">
            <ArrowLeftWhite />
            <ArrowRightWhite />
          </div>
        )
    }
  }

  return (
    <section className="fui-horzonal-cards songs-list" id={props.id}>
      {renderBg()}
      <div className="fui-container">
        <h2 className="section-title">
          {props.title}
        </h2>
        <Slider {...settings} className="horizontal-cards">
          {
            props.cards.map((card, idx) => (
              <Card key={idx} {...card}  />
            ))
          }
        </Slider>
        {
          props.more ? (
            <div className="align-center more">
              <Button btnStyle='secondary' link='{props.more.link}' size='' className="">{props.more.text}</Button>
            </div>
          ) : ''
        }
      </div>
    </section>
  );
}

LifeCircleSongsCarousel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  album: PropTypes.string,
  signer: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.objectOf(Card)
  ),
  bgStyle: PropTypes.string,
  more: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string
  })
}

export default LifeCircleSongsCarousel;